var createCommand = function createCommand(command) {
  var fn = function fn() {
    var _window;
    if (typeof window === 'undefined' || !window.CSM) {
      // eslint-disable-next-line no-console
      console.warn('CSM SDK has not been loaded!');
      return;
    }

    // @ts-ignore i give up
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    (_window = window).CSM.apply(_window, [command].concat(args));
  };
  return fn;
};

/**
 * Open the widget
 */
export var open = createCommand('open');

/**
 * Close the widget
 */
export var close = createCommand('close');

/**
 * Hide the widget off the screen
 */
export var hide = createCommand('hide');

/**
 * Show the widget on the screen
 */
export var show = createCommand('show');

/**
 * Update the widget style
 */
export var update = createCommand('update');

/**
 * Create a new conversation
 */
export var createNewConversation = createCommand('createNewConversation');

/**
 * Subscribe to the widget open event
 * @param callback - The callback to call when the widget is opened
 */
export var onOpen = createCommand('onOpen');

/**
 * Subscribe to the widget close event
 * @param callback - The callback to call when the widget is closed
 */
export var onClose = createCommand('onClose');

/**
 * Get the current conversation
 * @param callback - The callback to call when the conversation is retrieved
 */
export var getCurrentConversation = createCommand('getCurrentConversation');